document.addEventListener('click', function(e) {
    var trigger = e.target.classList.contains('swym-wishlist-context-menu');
    if(trigger) {
        var isSticky = document.querySelector('body').classList.contains('header-sticky');
        if(isSticky) {
          var headerHeight = document.querySelector('header .desktop-header').offsetHeight - 20;
        } else {
          var headerHeight = document.querySelector('header').offsetHeight - 23;
        }
        document.querySelector('.swym-wishlist-context-menu-content').style.top = headerHeight + 'px';
        document.querySelector('.swym-wishlist-context-menu-content').style.bottom = 'auto';
        console.log('click')
    } else {
        console.log('not clicked');
    }
})